function RatePkgReport() {
    return (
      <>
        <div className="font-bold mb-16 text-xl text-blue-800">Rate Pkg Report</div>
      </>
    );
  }
  
  export default RatePkgReport;